isFreeMonth